import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import BtnAdd from "../../Components/Commons/Buttons/BtnAdd";
import TextField from "../../Components/Commons/Forms/TextField";
import TextArea from "../../Components/Commons/Forms/TextArea";
import { getInventories } from "../../Components/Helpers/API/InventoryApi/InventoryApi";
import SelectField from "../../Components/Commons/Forms/SelectField";
import {
  validateInventory,
  validatePharmacy,
} from "../../Components/Helpers/Utilities/Validations/Pharmacy";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import BtnDelete from "../../Components/Commons/Buttons/BtnDelete";
import BtnClear from "../../Components/Commons/Buttons/BtnClear";
import {
  createItem,
  createSales,
} from "../../Components/Helpers/API/PharmacyApi/PharmacyApi";
import { toast } from "react-toastify";

export default function AddItem({ refetch }) {
  const [show, setShow] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [newItem, setNewItem] = useState({
    item: "",
    unit_price: "",
    stock: "",
    unit: "",
  });
  const [isError, setIsError] = useState({
    item: false,
    unit_price: false,
    stock: false,
    unit: false,
  });

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setNewItem((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setIsClicked(true);
    if (validateInventory(newItem, setIsError)) {
      const res = await createItem(newItem);
      if (res.data) {
        toast.success(res.data.message);
        handleClose();
        setNewItem({
          item: "",
          unit_price: "",
          stock: "",
        });
        refetch();
      } else if (res.error) {
        if (res.error?.status === 500) {
          toast.error(`Error 500: ${res.error.data.message}`);
        }
      }
    }
    setIsClicked(false);
  };

  return (
    <>
      <BtnAdd label={"+ Add Item"} size={"sm"} onClick={handleShow} />

      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="form-title">Add Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <TextField
                required
                id="item"
                name="item"
                formLabel={`Item`}
                size={`sm`}
                value={newItem.item}
                onChange={handleAddChange}
                isError={isError.item}
                errorMessage="Item is required"
              />
            </Col>
            <Col>
              <TextField
                required
                id="unit"
                name="unit"
                formLabel={`Unit`}
                size={`sm`}
                value={newItem.unit}
                onChange={handleAddChange}
                isError={isError.unit}
                errorMessage="Unit is required"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextField
                required
                id="unit_price"
                name="unit_price"
                formLabel={`Unit Price`}
                size={`sm`}
                value={newItem.unit_price}
                onChange={handleAddChange}
                isError={isError.unit_price}
                errorMessage="Unit price is required"
              />{" "}
            </Col>
            <Col>
              <TextField
                required
                id="stock"
                name="stock"
                formLabel={`Stock (Beginning Inv.)`}
                size={`sm`}
                value={newItem.stock}
                onChange={handleAddChange}
                isError={isError.stock}
                errorMessage="Stock is required"
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col>
              <TextArea
                id="description"
                name="description"
                value={newItem.description}
                onChange={handleAddChange}
                formLabel={`Description`}
                size={`sm`}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <BtnDelete
            label={"Close"}
            size={"md"}
            onClick={handleClose}
            isClicked={isClicked}
          />
          <BtnSave
            label={"Submit"}
            size={"md"}
            onClick={handleSubmit}
            isClicked={isClicked}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}
